import _IconLock from "@arco-design/web-react/icon/react-icon/IconLock";
import "@arco-design/web-react/es/Grid/style";
import _Grid from "@arco-design/web-react/es/Grid";
import "@arco-design/web-react/es/Space/style";
import _Space from "@arco-design/web-react/es/Space";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import "@arco-design/web-react/es/Form/style";
import _Form from "@arco-design/web-react/es/Form";
import "@arco-design/web-react/es/Input/style";
import _Input from "@arco-design/web-react/es/Input";
import _IconUser from "@arco-design/web-react/icon/react-icon/IconUser";
import "@arco-design/web-react/es/Message/style";
import _Message from "@arco-design/web-react/es/Message";
import "@arco-design/web-react/es/Steps/style";
import _Steps from "@arco-design/web-react/es/Steps";
import React, { useEffect, useRef, useState } from 'react';
import api from '@/utils/api';
import useLocale from '@/utils/useLocale';
import locale from './locale';
import styles from './style/index.module.less';
const Step = _Steps.Step;
export default function ResetPasswordForm() {
  const formRef = useRef();
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [otpSending, setOtpSending] = useState(false);
  const [otpCountdown, setOtpCountdown] = useState(0);
  const [currentStep, setCurrentStep] = useState(0);
  const [resendOtpCountdown, setResendOtpCountdown] = useState(0);
  const [verifiedEmail, setVerifiedEmail] = useState(''); // 添加用于存储已验证邮箱的状态

  const t = useLocale(locale);

  // 验证码倒计时效果
  useEffect(() => {
    let timer;
    if (otpCountdown > 0) {
      timer = setTimeout(() => setOtpCountdown(otpCountdown - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [otpCountdown]);

  // 重新发送验证码倒计时效果
  useEffect(() => {
    let timer;
    if (resendOtpCountdown > 0) {
      timer = setTimeout(() => setResendOtpCountdown(resendOtpCountdown - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [resendOtpCountdown]);

  // 发送验证码
  function sendOtp() {
    const email = formRef.current?.getFieldValue('email');
    if (!email) {
      setErrorMessage(t['reset.form.email.errMsg']);
      return;
    }
    setOtpSending(true);
    setErrorMessage('');
    setSuccessMessage('');
    api.post('/api/auth/reset-password/send-otp', {
      email
    }).then(() => {
      _Message.success(t['reset.form.otp.send.success']);
      setOtpCountdown(120); // 设置2分钟倒计时
      setResendOtpCountdown(120); // 设置重新发送验证码的2分钟倒计时
      setVerifiedEmail(email); // 保存已验证的邮箱
      setCurrentStep(1); // 切换到重置密码步骤
    }).catch(error => {
      // console.log(error);
      setErrorMessage(error?.response?.data?.message || t['reset.form.otp.send.fail']);
    }).finally(() => {
      setOtpSending(false);
    });
  }

  // 重新发送验证码
  function resendOtp() {
    const email = formRef.current?.getFieldValue('email');
    if (!email) {
      setErrorMessage(t['reset.form.email.errMsg']);
      return;
    }
    setOtpSending(true);
    setErrorMessage('');
    setSuccessMessage('');
    api.post('/api/auth/reset-password/send-otp', {
      email
    }).then(() => {
      _Message.success(t['reset.form.otp.send.success']);
      setResendOtpCountdown(120); // 设置2分钟倒计时
    }).catch(error => {
      // console.log(error);
      setErrorMessage(error?.response?.data?.message || t['reset.form.otp.send.fail']);
    }).finally(() => {
      setOtpSending(false);
    });
  }

  // 重置密码
  function resetPassword() {
    formRef.current?.validate().then(values => {
      setLoading(true);
      setErrorMessage('');
      setSuccessMessage('');
      api.post('/api/auth/reset-password', values).then(res => {
        const {
          data
        } = res;
        if (data.code === 200) {
          setSuccessMessage(t['reset.form.reset.success']);
          // 3秒后跳转到登录页
          setTimeout(() => {
            window.location.href = '/login';
          }, 3000);
        } else {
          setErrorMessage(data.message || t['reset.form.reset.fail']);
        }
      }).catch(error => {
        // console.log(error);
        setErrorMessage(error?.response?.data?.message || t['reset.form.reset.fail']);
      }).finally(() => {
        setLoading(false);
      });
    }).catch(error => {
      setErrorMessage(t['reset.form.reset.errMsg']);
    });
  }
  function onSubmitClick() {
    if (currentStep === 0) {
      sendOtp();
    } else {
      resetPassword();
    }
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles['reset-password-form-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['reset-password-form-title']
  }, t['reset.form.title']), /*#__PURE__*/React.createElement("div", {
    className: styles['reset-password-form-error-msg']
  }, errorMessage), /*#__PURE__*/React.createElement("div", {
    className: styles['reset-password-form-success-msg']
  }, successMessage), /*#__PURE__*/React.createElement(_Steps, {
    current: currentStep,
    className: styles['reset-password-steps']
  }, /*#__PURE__*/React.createElement(Step, {
    title: t['reset.form.sendOtp']
  }), /*#__PURE__*/React.createElement(Step, {
    title: t['reset.form.resetPassword']
  })), currentStep === 0 && /*#__PURE__*/React.createElement(_Form, {
    className: styles['login-form'],
    layout: "vertical",
    ref: formRef
  }, /*#__PURE__*/React.createElement(_Form.Item, {
    field: "email",
    rules: [{
      required: true,
      message: t['reset.form.email.errMsg']
    }]
  }, /*#__PURE__*/React.createElement(_Input, {
    prefix: /*#__PURE__*/React.createElement(_IconUser, null),
    placeholder: t['reset.form.email.placeholder'],
    onPressEnter: onSubmitClick
  })), /*#__PURE__*/React.createElement(_Space, {
    size: 16,
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(_Button, {
    type: "primary",
    long: true,
    onClick: sendOtp,
    loading: otpSending
  }, otpCountdown > 0 ? `${t['reset.form.otp.send.again']} (${otpCountdown}s)` : t['reset.form.otp.send']), /*#__PURE__*/React.createElement(_Button, {
    type: "text",
    long: true,
    onClick: () => window.location.href = '/login'
  }, t['login.form.login']))), currentStep === 1 && /*#__PURE__*/React.createElement(_Form, {
    className: styles['login-form'],
    layout: "vertical",
    ref: formRef,
    initialValues: {
      email: verifiedEmail
    }
  }, /*#__PURE__*/React.createElement(_Form.Item, {
    field: "email",
    rules: [{
      required: true,
      message: t['reset.form.email.errMsg']
    }]
  }, /*#__PURE__*/React.createElement(_Input, {
    prefix: /*#__PURE__*/React.createElement(_IconUser, null),
    placeholder: t['reset.form.email.placeholder'],
    onPressEnter: onSubmitClick,
    value: verifiedEmail // 设置邮箱值
    ,
    disabled: !!verifiedEmail // 如果有已验证邮箱，则禁用输入框
  })), /*#__PURE__*/React.createElement(_Form.Item, null, /*#__PURE__*/React.createElement(_Grid.Row, {
    gutter: 8
  }, /*#__PURE__*/React.createElement(_Grid.Col, {
    span: 12
  }, /*#__PURE__*/React.createElement(_Form.Item, {
    field: "otp",
    rules: [{
      required: true,
      message: t['reset.form.otp.errMsg']
    }]
  }, /*#__PURE__*/React.createElement(_Input, {
    placeholder: t['reset.form.otp.placeholder'],
    maxLength: 6,
    onPressEnter: onSubmitClick,
    style: {
      flex: 1
    }
  }))), /*#__PURE__*/React.createElement(_Grid.Col, {
    span: 12
  }, /*#__PURE__*/React.createElement(_Form.Item, null, /*#__PURE__*/React.createElement(_Button, {
    onClick: resendOtp,
    loading: otpSending,
    disabled: resendOtpCountdown > 0,
    style: {
      width: '100%'
    }
  }, resendOtpCountdown > 0 ? `${t['reset.form.otp.send.again']} (${resendOtpCountdown}s)` : t['reset.form.otp.send']))))), /*#__PURE__*/React.createElement(_Form.Item, {
    field: "password",
    rules: [{
      required: true,
      message: t['reset.form.password.errMsg']
    }]
  }, /*#__PURE__*/React.createElement(_Input.Password, {
    prefix: /*#__PURE__*/React.createElement(_IconLock, null),
    placeholder: t['reset.form.password.placeholder'],
    onPressEnter: onSubmitClick
  })), /*#__PURE__*/React.createElement(_Form.Item, {
    field: "password_confirmation",
    rules: [{
      required: true,
      message: t['reset.form.password_confirmation.errMsg']
    }, {
      validator: (value, callback) => {
        if (!value || formRef.current?.getFieldValue('password') === value) {
          callback();
        } else {
          callback(t['reset.form.password_confirmation.notMatch']);
        }
      }
    }]
  }, /*#__PURE__*/React.createElement(_Input.Password, {
    prefix: /*#__PURE__*/React.createElement(_IconLock, null),
    placeholder: t['reset.form.password_confirmation.placeholder'],
    onPressEnter: onSubmitClick
  })), /*#__PURE__*/React.createElement(_Space, {
    size: 16,
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(_Button, {
    type: "primary",
    long: true,
    onClick: resetPassword,
    loading: loading
  }, t['reset.form.reset']), /*#__PURE__*/React.createElement(_Button, {
    type: "text",
    long: true,
    onClick: () => window.location.href = '/login'
  }, t['login.form.login']))));
}